import React, { Component } from "react";
import $ from 'jquery'; 


import FilterDropdown from "../components/filterpage/FilterDropdown";
import FilterMinMax from "../components/filterpage/FilterMinMax";
import FilterCheckbox from "../components/filterpage/FilterCheckbox";


import StudyTable from "../components/tablepage/StudyTable";
import AssaysTable from "../components/tablepage/AssaysTable";
import ParticipantsTable from "../components/tablepage/ParticipantsTable";
import ArmsTable from "../components/tablepage/ArmsTable";
import SignaturesTable from "../components/tablepage/SignaturesTable";
import EventsTable from "../components/tablepage/EventsTable";


import '../components/filterpage/AllFilters.css';
import './AllPages.css';
import '../components/tablepage/TableComponents.css';


import { AiOutlineReload, AiOutlineDownload } from "react-icons/ai";
import { FaFilter } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { Puff } from 'react-loading-icons';

import axios from "axios";





export default class TablePage extends Component {

  componentDidMount(){
    document.title = "Data Access - ImmuneSpace"
  }

  constructor(props) {
    super(props);

    // planned visits & arms
    this.planned_visits_filter = [];
    this.arms_id_filter = [];

    // samples and assays
    this.tissue_sampled_filter = [];
    this.sample_type_filter =[];
    this.assay_filter = [];
    this.target_entity_filter = [];

    // immune exposure
    this.event_type_filter = [];
    this.event_category_filter = [];
    this.material_filter = [];
    this.disease_filter = [];

    // participants
    this.participant_id_filter = [];
    this.sex_filter = [];
    this.race_filter = [];
    this.age_min = 0;
    this.age_max = 100;
    this.age_unknown_filter = false; 


    // study
    this.study_id_filter = [];
    this.pmid_filter = [];
    this.authors_filter = [];
    this.has_signature_filter = false;
    this.curation_complete_filter = false;
    this.year_min = 2012;
    this.year_max = new Date().getFullYear();


    var search = window.location.search;
    this.query = search;

    var dropdownlist = [];
    var searchdropdown = '';
    var searchslider = '';
    var searchcheckbox = '';
    var searchordering_studies = '';
    var searchordering_participants = '';
    var searchordering_arms = '';
    var searchordering_events = '';
    var searchordering_assays = '';
    var searchordering_signatures = '';

    var ordering_tab = 'study_tab';
    // current selected tab
    this.current_tab = 'study-tab';
    // current selected table
    this.current_table = 'study-table';  

    // small screen filter tracking
    this.current_filter = 'small-filters-studies';
    


    // check if filters applied are correct, if yes then change window.location.search to reload the page
    var check_request_url = window.location.protocol + '//' + window.location.host + '/api_kb/check_all_request_get/' + search;
    this.check_request_values(check_request_url, search);
      


    if (search !== undefined && search !== ''){
   
      search = search.split('?')[1].split('&');

      for (var s of search) {

        var s_search = s.split('=')[1];
        var s_split = s_search.split('+');

        // if applied filter different from ordering
        if (!s.startsWith('ordering')){ 

          // planned visits & arms
          if (s.startsWith('planned_visits')){
            this.planned_visits_filter = s_split;
            searchdropdown += s+'&';
            for (var i0 of s_split){
              dropdownlist.push('planned_visits='+i0);
            }
          }

          else if (s.startsWith('arms_id')){
            this.arms_id_filter = s_split;
            searchdropdown += s+'&';
            for (var i19 of s_split){
              dropdownlist.push('arms_id='+i19);
            }
          }



          // assays
          else if (s.startsWith('tissue_sampled_filter')){
            this.tissue_sampled_filter = s_split;
            searchdropdown += s+'&';
            for (var i1 of s_split){
              dropdownlist.push('tissue_sampled_filter='+i1);
            }
          }

          else if (s.startsWith('sample_type_filter')){
            this.sample_type_filter = s_split;
            searchdropdown += s+'&';
            for (var i2 of s_split){
              dropdownlist.push('sample_type_filter='+i2);
            }
          }

          else if (s.startsWith('assay_filter')){
            this.assay_filter = s_split;
            searchdropdown += s+'&';
            for (var i3 of s_split){
              dropdownlist.push('assay_filter='+i3);
            }
          }

          else if (s.startsWith('target_entity_filter')){
            this.target_entity_filter = s_split;
            searchdropdown += s+'&';
            for (var i4 of s_split){
              dropdownlist.push('target_entity_filter='+i4);
            }
          }


          // events
          else if (s.startsWith('event_type_filter')){
            this.event_type_filter = s_split;
            searchdropdown += s+'&';
            for (var i5 of s_split){
              dropdownlist.push('event_type_filter='+i5);
            }
          }

          else if (s.startsWith('event_category_filter')){
            this.event_category_filter = s_split;
            searchdropdown += s+'&';
            for (var i6 of s_split){
              dropdownlist.push('event_category_filter='+i6);
            }
          }

          else if (s.startsWith('material_filter')){
            this.material_filter = s_split;
            searchdropdown += s+'&';
            for (var i7 of s_split){
              dropdownlist.push('material_filter='+i7);
            }
          }

          else if (s.startsWith('disease_filter')){
            this.disease_filter = s_split;
            searchdropdown += s+'&';
            for (var i8 of s_split){
              dropdownlist.push('disease_filter='+i8);
            }
          }


          // participants
          else if (s.startsWith('participant_id_filter')){
            this.participant_id_filter = s_split;
            searchdropdown += s+'&';
            for (var i9 of s_split){
              dropdownlist.push('participant_id_filter='+i9);
            }
          }

          else if (s.startsWith('sex_filter')){
            this.sex_filter = s_split;
            searchdropdown += s+'&';
            for (var i10 of s_split){
              dropdownlist.push('sex_filter='+i10);
            }
          }

          else if (s.startsWith('race_filter')){
            this.race_filter = s_split;
            searchdropdown += s+'&';
            for (var i11 of s_split){
              dropdownlist.push('race_filter='+i11);
            }
          }

          else if (s.startsWith('age_filter_min')){
            this.age_min = s_search;
            searchslider += s+'&';
            for (var i12 of s_split){
              dropdownlist.push('age_filter_min=age min:'+i12);
            }
          }

          else if (s.startsWith('age_filter_max')){
            this.age_max = s_search;
            searchslider += s+'&';
            for (var i13 of s_split){
              dropdownlist.push('age_filter_max=age max:'+i13);
            }
          } 

          else if (s.startsWith('age_unknown_filter')){
            this.age_unknown_filter = s_search;
            searchcheckbox += s+'&';
            if (this.age_unknown_filter === "true"){
              this.age_unknown_filter = true;
            } else { this.age_unknown_filter = false; }
            dropdownlist.push('age_unknown_filter=hide age unknown:'+this.age_unknown_filter);
          }


          // study
          else if (s.startsWith('study_id_filter')){
            this.study_id_filter = s_split;
            searchdropdown += s+'&';
            for (var i14 of s_split){
              dropdownlist.push('study_id_filter='+i14);
            }
          }

          else if (s.startsWith('pmid_filter')){
            this.pmid_filter = s_split;
            searchdropdown += s+'&';
            for (var i15 of s_split){
              dropdownlist.push('pmid_filter=PMID:'+i15);
            }
          }

          else if (s.startsWith('authors_filter')){
            this.authors_filter = s_split;
            searchdropdown += s+'&';
            for (var i16 of s_split){
              dropdownlist.push('authors_filter='+i16);
            }
          }

          else if (s.startsWith('year_filter_min')){
            this.year_min = s_search;
            searchslider += s+'&';
            for (var i17 of s_split){
              dropdownlist.push('year_filter_min=year min:'+i17);
            }
          }

          else if (s.startsWith('year_filter_max')){
            this.year_max = s_search;
            searchslider += s+'&';
            for (var i18 of s_split){
              dropdownlist.push('year_filter_max=year max:'+i18);
            }
          }

          else if (s.startsWith('has_signature')){
            this.has_signature_filter = s_search;
            searchcheckbox += s+'&';
            if (this.has_signature_filter === "true"){
              this.has_signature_filter = true;
            } else { this.has_signature_filter = false; }
            dropdownlist.push('has_signature=has signature:'+this.has_signature_filter);
          }

          else if (s.startsWith('curation_complete')){
            this.curation_complete_filter = s_search;
            searchcheckbox += s+'&';
            if (this.curation_complete_filter === "true"){
              this.curation_complete_filter = true;
            } else { this.curation_complete_filter = false; }
            dropdownlist.push('curation_complete=curation complete:'+this.curation_complete_filter);
          }
        
        }

        else {

          if (s.startsWith('ordering_studies') || s.startsWith('ordering_studies_dir')){
            searchordering_studies += s+'&';
          }

          else if (s.startsWith('ordering_participants') || s.startsWith('ordering_participants_dir')){
            searchordering_participants += s+'&';
          }

          else if (s.startsWith('ordering_arms') || s.startsWith('ordering_arms_dir')){
            searchordering_arms += s+'&';
          }

          else if (s.startsWith('ordering_events') || s.startsWith('ordering_events_dir')){
            searchordering_events += s+'&';
          }

          else if (s.startsWith('ordering_assays') || s.startsWith('ordering_assays_dir')){
            searchordering_assays += s+'&';
          }

          else if (s.startsWith('ordering_signatures') || s.startsWith('ordering_signatures_dir')){
            searchordering_signatures += s+'&';
          }

          else if (s.startsWith('ordering_tab')){
            ordering_tab = s_search;
            // current selected tab
            this.current_tab = s_search.split('_')[0]+'-tab';
            // current selected table
            this.current_table = s_search.split('_')[0]+'-table'; 
          }

        }

      
      }
    
    }
      

    // initial search
    this.state = {
      dropdownlist: dropdownlist,
      oldsearchdropdown: searchdropdown.slice(0, -1),
      searchdropdown: searchdropdown.slice(0, -1),
      oldsearchslider: searchslider.slice(0, -1),
      searchslider: searchslider.slice(0, -1),
      oldsearchcheckbox: searchcheckbox.slice(0, -1),
      searchcheckbox: searchcheckbox.slice(0, -1),
      searchordering_studies: searchordering_studies.slice(0, -1),
      searchordering_participants: searchordering_participants.slice(0, -1),
      searchordering_arms: searchordering_arms.slice(0, -1),
      searchordering_events: searchordering_events.slice(0, -1),
      searchordering_assays: searchordering_assays.slice(0, -1),
      searchordering_signatures: searchordering_signatures.slice(0, -1),
      open_tab: ordering_tab,
      age_min: 0,
      age_max: 100,
      year_min: 2012,
      year_max: new Date().getFullYear(),
      // table data
      loadingData: false,
      // table length
      studieslength: '...',
      participantslength: '...',
      armslength: '...',
      eventslength: '...',
      assayslength: '...', 
      signatureslength: '...',
      // error filter
      error_bool: false,
      error_message: '',
    };  
    
    
  }


  // ACTIONS ON FILTERS
  onDropdownChange = (filters_selected) => {

    var search = '';

    for (var col in filters_selected){

      if (filters_selected[col].length > 0){
        var col_search = col+'=';

        for (var item of filters_selected[col]){
          col_search += item.value + '+';
        }

        // remove last +
        col_search = col_search.slice(0, -1);
        
        search += col_search + '&'

      }
    }

    // remove last &
    search = search.slice(0, -1);
    // search = this.state.searchdropdown + '&' + search.slice(0, -1);


    if (search !== this.state.oldsearchdropdown){
      // color update buttons
      $('#apply-filters')[0].style.display = "block";
      $('#apply-filters-small')[0].style.display = "block";
      // resize filters-tile div    
      $('.TablePage .filters-tile')[0].style.height = '80vh';
    }

    else {
      // color update buttons
      $('#apply-filters')[0].style.display = "none";
      $('#apply-filters-small')[0].style.display = "none";
      // resize filters-tile div    
      $('.TablePage .filters-tile')[0].style.height = '88vh';      
    }

    this.setState({
      searchdropdown: search,
    });
  }

  onSliderChange = (slider_selected) => {

    var search = '';

    for (var col in slider_selected){

      if (Object.keys(slider_selected[col]).length > 0){

        // for age
        if (col === 'age_filter'){
          if (slider_selected[col].min !== this.state.age_min){
            search += 'age_filter_min=' + slider_selected[col].min + '&';
          }
          if (slider_selected[col].max !== this.state.age_max){
            search += 'age_filter_max=' + slider_selected[col].max + '&';
          }
        }

        // for year
        else if (col === 'year_filter'){
          if (slider_selected[col].min !== this.state.year_min){
            search += 'year_filter_min=' + slider_selected[col].min + '&';
          }
          if (slider_selected[col].max !== this.state.year_max){
            search += 'year_filter_max=' + slider_selected[col].max + '&';
          }
        }    
      }
    }

    // remove last &
    search = search.slice(0, -1);

    if (search !== this.state.oldsearchslider){
      // color update buttons
      $('#apply-filters')[0].style.display = "block";
      $('#apply-filters-small')[0].style.display = "block";
      // resize filters-tile div    
      $('.TablePage .filters-tile')[0].style.height = '80vh';
    }
    else {
      // color update buttons
      $('#apply-filters')[0].style.display = "none";
      $('#apply-filters-small')[0].style.display = "none";
      // resize filters-tile div    
      $('.TablePage .filters-tile')[0].style.height = '88vh';      
    }

    this.setState({
      searchslider: search,
    });    

  }

  onCheckboxChange = (checkbox_selected) => {
    var search = '';

    for (var col in checkbox_selected){
      if (checkbox_selected[col]){
        if (col === 'has_signature'){
          search += 'has_signature=true&';
        }
  
        else if (col === 'curation_complete'){
          search += 'curation_complete=true&';
        }
        
        else if (col === 'age_unknown_filter'){
          search += 'age_unknown_filter=true&';
        }
      }
    }

    // remove last &
    search = search.slice(0, -1);

    this.setState({searchcheckbox: search});

    if (search !== this.state.oldsearchcheckbox){
      // color update buttons
      $('#apply-filters')[0].style.display = "block";
      $('#apply-filters-small')[0].style.display = "block";
      // resize filters-tile div    
      $('.TablePage .filters-tile')[0].style.height = '80vh';
    }
    else {
      // color update buttons
      $('#apply-filters')[0].style.display = "none";
      $('#apply-filters-small')[0].style.display = "none";
      // resize filters-tile div    
      $('.TablePage .filters-tile')[0].style.height = '88vh';      
    }

    this.setState({
      searchcheckbox: search,
    });
  }

  getLength = (length, table) => {
    if (table === "study") {
      this.setState(
        {
          studieslength: length,
        }
      )  
    }
    if (table === "participants") {
      this.setState(
        {
          participantslength: length,
        }
      )  
    }
    if (table === "arms") {
      this.setState(
        {
          armslength: length,
        }
      )  
    }
    if (table === "events") {
      this.setState(
        {
          eventslength: length,
        }
      )  
    }
    if (table === "assays") {
      this.setState(
        {
          assayslength: length,
        }
      )  
    }
    if (table === "signatures") {
      this.setState(
        {
          signatureslength: length,
        }
      )  
    }
  }


  // DELETE FILTERS FROM TOP TILE
  deleteItemFromFilters = (item) => {
    var group_filter = item.split('=')[0];
    var item_filter = item.split('=')[1];

    var search = window.location.search.split(group_filter);
    var search_keep = [search[0], search[1].split('&').slice(1).join('&')];

    var new_search = '';


    var search_filter_to_modify = search[1].split('&')[0];

    if (search_filter_to_modify.includes('+')){
      if (search_filter_to_modify.includes(item_filter+'+')){
        search_filter_to_modify = search_filter_to_modify.replace((item_filter+'+'), '');
      }
      else if (search_filter_to_modify.includes('+'+item_filter)){
        search_filter_to_modify = search_filter_to_modify.replace(('+'+item_filter), '');
      }
      
      new_search = search_keep[0] + group_filter + search_filter_to_modify 
      
      if (search_keep[1] !== ''){
        new_search += '&' + search_keep[1];
      }
    }
    
    else {
      new_search = search_keep[0] + search_keep[1];
    }

    // remove last & if exists
    if (new_search.endsWith('&')){
      new_search = new_search.slice(0, -1);
    }

    window.location.search = new_search;

  }


  // CHECK FILTER VALUES INSIDE REQUEST.GET
  check_request_values = async (url, search) => {
    this.setState({ loadingData: true }); // Set loading state to true before fetching

    try {
      const response = await axios.get(url);

      this.setState({
        error_bool: response.data.error,
        error_message: response.data.message,
        loadingData: false, 
      });

      // if no error, then send call to rebuild tables
      if (response.data.error){
        
        setTimeout(() => window.location.search = '', 4000); // auto-close after 4s
        
      }

    } 
    
    catch (error) {
      console.error('Error fetching table data:', error);
      this.setState({
        error_message: 'Error fetching error message.',
        loadingData: false,
      });
    }
  };




  // ACTIONS FOR COLUMN ORDERING
  combineSearch = () => {  
    var seach_open_tab = '';
    if (this.state.open_tab) {
      seach_open_tab = 'ordering_tab=' +this.state.open_tab;
    }

    const queryParams = [
      this.state.searchdropdown,
      this.state.searchcheckbox,
      this.state.searchslider,
      this.state.searchordering_studies,
      this.state.searchordering_participants,
      this.state.searchordering_events,
      this.state.searchordering_assays,
      this.state.searchordering_signatures,
      this.state.searchordering_arms,
      seach_open_tab
    ];
    
    const filteredParams = queryParams.filter(param => param !== '');    
    const queryString = filteredParams.join('&');
    
    var search = '?' + queryString;
    window.location.search = search;
  }


  onStudiesColumnOrdering = (column, order) => {
    // this.setstate used when we need to rerender the page without reloading.
    // since we need to use the new value of state right away to change the url and reload the page with a new url, it will render on load
    this.state.searchordering_studies = 'ordering_studies='+column+'&ordering_studies_dir='+order;
    this.state.open_tab = 'study_tab';
    this.combineSearch();
  }

  onParticipantsColumnOrdering = (column, order) => {
    this.state.searchordering_participants = 'ordering_participants='+column+'&ordering_participants_dir='+order;
    this.state.open_tab = 'participants_tab';
    this.combineSearch();
  }

  onArmsColumnOrdering = (column, order) => {
    this.state.searchordering_arms = 'ordering_arms='+column+'&ordering_arms_dir='+order;
    this.state.open_tab = 'arms_tab';
    this.combineSearch();
  }

  onEventsColumnOrdering = (column, order) => {
    this.state.searchordering_events= 'ordering_events='+column+'&ordering_events_dir='+order;
    this.state.open_tab = 'events_tab';
    this.combineSearch();
  }

  onAssaysColumnOrdering = (column, order) => {
    this.state.searchordering_assays= 'ordering_assays='+column+'&ordering_assays_dir='+order;
    this.state.open_tab = 'assays_tab';
    this.combineSearch();
  }

  onSignaturesColumnOrdering = (column, order) => {
    this.state.searchordering_signatures= 'ordering_signatures='+column+'&ordering_signatures_dir='+order;
    this.state.open_tab = 'signatures_tab';
    this.combineSearch();
  }




  selectTable = (tab_id) => {
    var table_id = tab_id+'le';

    // remove current selected-tab and selected-table
    $('#'+this.current_tab).removeClass('selected-tab');
    $('#'+this.current_table).removeClass('selected-table');

    // select new tab and new table
    $('#'+tab_id).addClass('selected-tab');
    $('#'+table_id).addClass('selected-table');
    this.current_tab = tab_id;
    this.current_table = table_id;

    this.state.open_tab = tab_id.replace('-', '_');
  }


  
  // FILTER ON SMALL SCREENS
  openFilterDivSmallScreen = () => {
    if ($('#col-filters-small').hasClass('small-filters-not-opened')){
      $('#col-filters-small').removeClass('small-filters-not-opened');
      $('#col-filters-small').addClass('small-filters-opened');
      $('.results-tab-dropdown').addClass('small-filter-open');
      $('.tables-tile').addClass('small-filter-open');
      $('#selected-filters-list').addClass('small-filter-open');
    }

    else {
      $('#col-filters-small').addClass('small-filters-not-opened');
      $('#col-filters-small').removeClass('small-filters-opened');
      $('.results-tab-dropdown').removeClass('small-filter-open');
      $('.tables-tile').removeClass('small-filter-open');
      $('#selected-filters-list').removeClass('small-filter-open');
    }

  }

  openFilterGroup = (filter_group) => {

    var filter_group_tab = filter_group + '-tab';

    // remove current filter tab and filter group selected 
    $('#'+this.current_filter).removeClass('group-filters-list-selected');
    $('#'+this.current_filter+'-tab').removeClass('group-filters-selected');

    // select new tab and new table
    $('#'+filter_group_tab).addClass('group-filters-selected');
    $('#'+filter_group).addClass('group-filters-list-selected');
    this.current_filter = filter_group;
    
  }



  render(){

    return (
      <div className="TablePage">

        {this.state.error_bool ? (

          <div className="modal-overlay">
            <div className="error-content">
              <h2>Invalid Filters</h2>
              <p>{this.state.error_message || "Some filters applied are invalid. Reloading now..."}</p>
            </div>
          </div>

        ):

          <div class="query-content">

            <div className="col-filters">

              <div>

                <div className="filters-tile-border">

                  <div>
                    <div class="filters-page-description">
                        <div class="info">
                          Select one or more filter parameters to query ImmuneSpace data.
                          <a class="info-icon" title="Click to go to tutorial" href="/query-app-tutorial" target="_blank"><i class="fa-regular fa-circle-question"></i></a>
                        </div>
                    </div>
                  </div>

                  <div id="apply-filters" className="button-redirect">
                    <a onClick={this.combineSearch}>
                        <button>
                          <AiOutlineReload/>
                          <p>Apply Filter(s)</p>
                        </button>
                      </a>
                  </div>

                  <div className="reset-filters">
                    <a href={`/query/results/?`}>
                      <button>
                        <p>Reset Filters</p>
                      </button>
                    </a>
                    <div className="opacity-fade-out"></div>
                  </div>

                  <div className="filters-tile">

                    <div className=" col-12 filters-group">

                      <div className="row">

                        <div className="filters-group-title">Studies</div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="Study ID" id="study_id_filter" data="get_study_id_dropdown" finder={false}  example='Ex: SDY112' onDropdownChange={this.onDropdownChange} selected={this.study_id_filter} />
                        </div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="PMID" id="pmid_filter" data="get_pubmed_id_dropdown" finder={false} example='Ex: 28092664' onDropdownChange={this.onDropdownChange} selected={this.pmid_filter} />
                        </div>

                        <div className="col-12">
                          <FilterDropdown title="Authors" id="authors_filter" data="get_authors_dropdown" finder={false} example='Ex: Sette A' onDropdownChange={this.onDropdownChange} selected={this.authors_filter} />
                        </div>

                        <div className="col-12 side-filter">
                          <FilterMinMax title="Initial Data Release" id="year_filter" onSliderChange={this.onSliderChange} selected_min={this.year_min} selected_max={this.year_max} />
                        </div>

                        <div className="col-12">
                          <FilterCheckbox title="Has Signature" id="has_signature" text="Has Signature" onCheckboxChange={this.onCheckboxChange} isSelected={this.has_signature_filter} />
                        </div>

                        <div className="col-12">
                          <FilterCheckbox title="Curation Complete" id="curation_complete" text="Curation Complete" onCheckboxChange={this.onCheckboxChange} isSelected={this.curation_complete_filter} />
                        </div>

                        <div className="col-12">
                          <FilterDropdown title="Planned Visits" id="planned_visits" data="get_planned_visits_dropdown" finder={false} example='Ex: PV1' onDropdownChange={this.onDropdownChange} selected={this.planned_visits_filter} />
                        </div>

                        <div className="col-12">
                          <FilterDropdown title="Arm ID" id="arms_id" data="get_arms_id_dropdown" finder={false} example='Ex: ARM226' onDropdownChange={this.onDropdownChange} selected={this.arms_id_filter} />
                        </div>

                      </div>

                    </div>

                    <div className=" col-12 filters-group">

                      <div className="row">

                        <div className="filters-group-title">Participants</div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="Participant ID" id="participant_id_filter" data="get_participant_id_dropdown" finder={false} example='Ex: SUB71252' onDropdownChange={this.onDropdownChange} selected={this.participant_id_filter} />
                        </div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="Biological Sex" id="sex_filter" data="get_biological_sex_dropdown" finder={false} example='Ex: female' onDropdownChange={this.onDropdownChange} selected={this.sex_filter} />
                        </div>

                        <div className="col-12 side-filter">
                          <FilterMinMax title="Age" id="age_filter" onSliderChange={this.onSliderChange} selected_min={this.age_min} selected_max={this.age_max} />
                          <FilterCheckbox title="Age Unknown" id="age_unknown_filter" text="Hide Age Unknown" onCheckboxChange={this.onCheckboxChange} isSelected={this.age_unknown_filter} />
                        </div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="Race" id="race_filter" data="get_race_dropdown" finder={false} example='Ex: white' onDropdownChange={this.onDropdownChange} selected={this.race_filter} />
                        </div>

                      </div>

                    </div>

                    <div className="col-12 filters-group">

                      <div className="row">

                        <div className="filters-group-title">Events / Samples</div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="Event Type" id="event_type_filter" data="get_event_type_dropdown" finder={false} example="Ex: vaccination" onDropdownChange={this.onDropdownChange} selected={this.event_type_filter} />
                        </div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="Event Category" id="event_category_filter" data="get_event_category_dropdown" finder={false} example="Ex: exposure" onDropdownChange={this.onDropdownChange} selected={this.event_category_filter} />
                        </div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="Material" id="material_filter" data="get_material_dropdown" finder={false} example="Ex: influenza a virus" onDropdownChange={this.onDropdownChange} selected={this.material_filter} />
                        </div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="Disease Name" id="disease_filter" data="get_disease_dropdown" finder={false} example="Ex: influenza" onDropdownChange={this.onDropdownChange} selected={this.disease_filter} />
                        </div>

                      </div>
                    
                    </div>

                    <div className="col-12 filters-group bottom-space">

                      <div className="row">

                        <div className="filters-group-title">Assays / Assessments</div>

                        <div className="col-12 side-filter">
                          <FilterDropdown disabled title="Tissue Sampled" id="tissue_sampled_filter" data="" finder={false} example="Ex: blood" onDropdownChange={this.onDropdownChange} selected={this.tissue_sampled_filter} />
                        </div>

                        <div className="col-12">
                          <FilterDropdown title="Sample Type" id="sample_type_filter" data="get_sample_type_dropdown" finder={false} example="Ex: blood" onDropdownChange={this.onDropdownChange} selected={this.sample_type_filter} />
                        </div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="Assay Type" id="assay_filter" data="get_assay_type_dropdown" finder={false} example="Ex: ELISA" onDropdownChange={this.onDropdownChange} selected={this.assay_filter} />
                        </div>

                        <div className="col-12 side-filter">
                          <FilterDropdown title="Target Entity (analyte)" id="target_entity_filter" data="get_target_entity_dropdown" finder={false} example="Ex: IL1A" onDropdownChange={this.onDropdownChange} selected={this.target_entity_filter} />
                        </div>

                      </div>

                    </div>

                  </div>

                </div>
              
              </div>

            </div>


            <div className="col-tables">

              <div className="results-tab row"> 
                <div id="study-tab" className={this.state.open_tab === "study_tab" ? "col-2 data-tab selected-tab" : "col-2 data-tab"}>
                    <div onClick={() => { this.selectTable('study-tab') }}>
                      Studies <small>({this.state.studieslength})</small>
                    </div>
                </div>
                <div id="arms-tab" className={this.state.open_tab === "arms_tab" ? "col-2 data-tab selected-tab" : "col-2 data-tab"}>
                  <div onClick={() => { this.selectTable('arms-tab') }}>
                    Arms <small>({this.state.armslength})</small>
                  </div>
                </div>
                <div id="participants-tab" className={this.state.open_tab === "participants_tab" ? "col-2 data-tab selected-tab" : "col-2 data-tab"}>
                  <div onClick={() => { this.selectTable('participants-tab') }}>
                    Participants <small>({this.state.participantslength})</small>
                  </div>
                </div>
                <div id="events-tab" className={this.state.open_tab === "events_tab" ? "col-3 data-tab selected-tab" : "col-3 data-tab"}>
                  <div onClick={() => { this.selectTable('events-tab') }}>
                    Events/Samples <small>({this.state.eventslength})</small>
                  </div>
                </div>
                <div id="assays-tab" className={this.state.open_tab === "assays_tab" ? "col-3 data-tab selected-tab" : "col-3 data-tab"}>
                  <div onClick={() => { this.selectTable('assays-tab') }}>
                    Assays/Assessments <small>({this.state.assayslength})</small>
                  </div>
                </div>
                <div id="signatures-tab" className={this.state.open_tab === "signatures_tab" ? "col-2 data-tab selected-tab" : "col-2 data-tab"}>
                  <div onClick={() => { this.selectTable('signatures-tab') }}>
                    Signatures <small>({this.state.signatureslength})</small>
                  </div>
                </div>
              </div>

              <div className="results-tab-small">
                <div className="results-tab-dropdown">
                  <select id="select-table-tab" class="form-select" aria-label="Select table" onChange={(el) => this.selectTable(el.target.value)}>
                    <option id="study-tab-option" value="study-tab" selected={this.state.open_tab === "study_tab"}>
                      Studies <small>({this.state.studieslength})</small>
                    </option>
                    
                    <option id="arms-tab-option" value="arms-tab" selected={this.state.open_tab === "arms_tab"}>
                      Arms <small>({this.state.armslength})</small>
                    </option>

                    <option id="participants-tab-option" value="participants-tab" selected={this.state.open_tab === "participants_tab"}>
                      Participants <small>({this.state.participantslength})</small>
                    </option>

                    <option id="events-tab-option" value="events-tab" selected={this.state.open_tab === "events_tab"}>
                      Events/Samples <small>({this.state.eventslength})</small>
                    </option>

                    <option id="assays-tab-option" value="assays-tab" selected={this.state.open_tab === "assays_tab"}>
                      Assays/Assessments <small>({this.state.assayslength})</small>
                    </option>

                    <option id="signatures-tab-option" value="signatures-tab" selected={this.state.open_tab === "signatures_tab"}>
                      Signatures <small>({this.state.signatureslength})</small>
                    </option>

                  </select>
                </div>

                <div className="results-tab-filters" onClick={() => this.openFilterDivSmallScreen()}>
                    <FaFilter/>
                    { this.state.dropdownlist.length > 0 ? <sub>{this.state.dropdownlist.length}</sub> : null }
                </div>

                <div id="col-filters-small" className="small-filters-not-opened">

                    <div className="col-filters-options">
                      <div id="small-filters-studies-tab" className="col-filters-options-title group-filters-selected" onClick={()=>this.openFilterGroup('small-filters-studies')}>Studies</div>
                      <div id="small-filters-participants-tab" className="col-filters-options-title" onClick={()=>this.openFilterGroup('small-filters-participants')}>Participants</div>
                      <div id="small-filters-events-tab" className="col-filters-options-title" onClick={()=>this.openFilterGroup('small-filters-events')}>Events/Samples</div>
                      <div id="small-filters-assays-tab" className="col-filters-options-title" onClick={()=>this.openFilterGroup('small-filters-assays')}>Assays/Assessments</div>
                    </div>

                    <div>
                      <div id="apply-filters-small" className="button-redirect">
                        <a onClick={this.combineSearch}>
                          <button>
                            <AiOutlineReload/>
                            <p>Apply Filter(s)</p>
                          </button>
                        </a>
                      </div>

                      <div class="reset-filters">
                        <a href={`/query/results/?`}>
                            <button>
                              <p>Reset Filters</p>
                            </button>
                        </a>
                      </div>
                    </div>

                    <div>

                      <div id="small-filters-studies" className="group-filters-list group-filters-list-selected">
                        <FilterDropdown title="Study ID" id="study_id_filter" data="get_study_id_dropdown" finder={false}  example='Ex: SDY112' onDropdownChange={this.onDropdownChange} selected={this.study_id_filter} />
                        <FilterDropdown title="PMID" id="pmid_filter" data="get_pubmed_id_dropdown" finder={false} example='Ex: 28092664' onDropdownChange={this.onDropdownChange} selected={this.pmid_filter} />
                        <FilterDropdown title="Authors" id="authors_filter" data="get_authors_dropdown" finder={false} example='Ex: Sette A' onDropdownChange={this.onDropdownChange} selected={this.authors_filter} />
                        <FilterMinMax title="Initial Data Release" id="year_filter" onSliderChange={this.onSliderChange} selected_min={this.year_min} selected_max={this.year_max} />
                        <FilterCheckbox title="Has Signature" id="has_signature" text="Has Signature" onCheckboxChange={this.onCheckboxChange} isSelected={this.has_signature_filter} />
                        <FilterCheckbox title="Curation Complete" id="curation_complete" text="Curation Complete" onCheckboxChange={this.onCheckboxChange} isSelected={this.curation_complete_filter} />
                        <FilterDropdown title="Planned Visits" id="planned_visits" data="get_planned_visits_dropdown" finder={false} example='Ex: PV1' onDropdownChange={this.onDropdownChange} selected={this.planned_visits_filter} />
                        <FilterDropdown title="Arm ID" id="arms_id" data="get_arms_id_dropdown" finder={false} example='Ex: ARM226' onDropdownChange={this.onDropdownChange} selected={this.arms_id_filter} />
                      </div>

                      <div id="small-filters-participants" className="group-filters-list">
                        <FilterDropdown title="Participant ID" id="participant_id_filter" data="get_participant_id_dropdown" finder={false} example='Ex: SUB71252' onDropdownChange={this.onDropdownChange} selected={this.participant_id_filter} />
                        <FilterDropdown title="Biological sex" id="sex_filter" data="get_biological_sex_dropdown" finder={false} example='Ex: female' onDropdownChange={this.onDropdownChange} selected={this.sex_filter} />
                        <FilterMinMax title="Age" id="age_filter" onSliderChange={this.onSliderChange} selected_min={this.age_min} selected_max={this.age_max} />
                        <FilterCheckbox title="Age Unknown" id="age_unknown_filter" text="Hide Age Unknown" onCheckboxChange={this.onCheckboxChange} isSelected={this.age_unknown_filter} />
                        <FilterDropdown title="Race" id="race_filter" data="get_race_dropdown" finder={false} example='Ex: white' onDropdownChange={this.onDropdownChange} selected={this.race_filter} />
                      </div>

                      <div id="small-filters-events" className="group-filters-list">
                        <FilterDropdown title="Event type" id="event_type_filter" data="get_event_type_dropdown" finder={false} example="Ex: vaccination" onDropdownChange={this.onDropdownChange} selected={this.event_type_filter} />
                        <FilterDropdown title="Event Category" id="event_category_filter" data="get_event_category_dropdown" finder={false} example="Ex: exposure" onDropdownChange={this.onDropdownChange} selected={this.event_category_filter} />
                        <FilterDropdown title="Material" id="material_filter" data="get_material_dropdown" finder={false} example="Ex: influenza a virus" onDropdownChange={this.onDropdownChange} selected={this.material_filter} />
                        <FilterDropdown title="Disease name" id="disease_filter" data="get_disease_dropdown" finder={false} example="Ex: influenza" onDropdownChange={this.onDropdownChange} selected={this.disease_filter} />
                      </div>

                      <div id="small-filters-assays" className="group-filters-list">
                        <FilterDropdown disabled title="Tissue sampled" id="tissue_sampled_filter" data="" finder={false} example="Ex: blood" onDropdownChange={this.onDropdownChange} selected={this.tissue_sampled_filter} />
                        <FilterDropdown title="Sample Type" id="sample_type_filter" data="get_sample_type_dropdown" finder={false} example="Ex: blood" onDropdownChange={this.onDropdownChange} selected={this.sample_type_filter} />
                        <FilterDropdown title="Assay type" id="assay_filter" data="get_assay_type_dropdown" finder={false} example="Ex: ELISA" onDropdownChange={this.onDropdownChange} selected={this.assay_filter} />
                        <FilterDropdown title="Target Entity (analyte)" id="target_entity_filter" data="get_target_entity_dropdown" finder={false} example="Ex: IL1A" onDropdownChange={this.onDropdownChange} selected={this.target_entity_filter} />
                      </div>
                    
                    </div>

                </div>

              </div>

              <div id="selected-filters-list" className={ this.state.dropdownlist !== '' ? 'filter-list-active' : ''}>

                {this.state.dropdownlist.map((el, i) => {

                  return (
                    <div className="filter-list-item" onClick={() => { this.deleteItemFromFilters(el) }}>
                      {el.split('=')[1].replaceAll('_', ' ').replaceAll('*', '+').replaceAll('!', '/')}
                      <span><RxCross2/></span>
                    </div>
                  )
                })}

              </div>
              
              {this.state.loadingData ? (
                  <div className="loader-container">
                      <Puff stroke="#ccd8de" strokeWidth={5}/>
                      <p>Loading...</p>
                  </div>
              ):(

                <div className="tables-tile">

                  <div id="study-table" className={this.state.open_tab === "study_tab" ? "data-table selected-table" : "data-table"}>              
                    <StudyTable 
                      query={this.query}
                      length={this.getLength}
                      onColumnOrdering={this.onStudiesColumnOrdering}
                    />
                  </div>

                  <div id="arms-table" className={this.state.open_tab === "arms_tab" ? "data-table selected-table" : "data-table"}>
                    <ArmsTable 
                      query={this.query} 
                      length={this.getLength}
                      onColumnOrdering={this.onArmsColumnOrdering}
                    />
                  </div>

                  <div id="participants-table" className={this.state.open_tab === "participants_tab" ? "data-table selected-table" : "data-table"}>
                    <ParticipantsTable 
                      query={this.query} 
                      length={this.getLength}
                      onColumnOrdering={this.onParticipantsColumnOrdering}
                    />
                  </div>

                  <div id="events-table" className={this.state.open_tab === "events_tab" ? "data-table selected-table" : "data-table"}>
                    <EventsTable 
                      query={this.query} 
                      length={this.getLength}
                      onColumnOrdering={this.onEventsColumnOrdering}
                    />
                  </div>

                  <div id="assays-table" className={this.state.open_tab === "assays_tab" ? "data-table selected-table" : "data-table"}>
                    <AssaysTable 
                      query={this.query} 
                      length={this.getLength}
                      onColumnOrdering={this.onAssaysColumnOrdering}
                    />
                  </div>

                  <div id="signatures-table" className={this.state.open_tab === "signatures_tab" ? "data-table selected-table" : "data-table"}>
                    <SignaturesTable 
                      query={this.query} 
                      length={this.getLength}
                      onColumnOrdering={this.onSignaturesColumnOrdering}
                    />
                  </div>

                </div>

              )}

            </div>

          </div>

        }

      </div>
    );
  }
    
}

// export default TablePage;

